export const defaultCookieOptions = {
  maxAge: 86400 * 365, // 1 year
  sameSite: "lax",
};
